import { ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy, inject, input, output } from "@angular/core";

import { QdmService, RankItem, ServiceItem } from "../../Services/qdm.service";
import { GestionService } from "app/Services/gestion.service";
import { OrderByPipe } from "app/Pipes/OrderBy.pipe";
import { Subscription } from "rxjs";

@Component({
    selector: "composantes-scrolling-category",
    imports: [OrderByPipe],
    template: `
<div class="border border-gris-3 overflow-x-auto h-12 md:h-32 sticky top-0 bg-white w-full flex items-center gap-2 py-2 px-2 md:px-6 overflow-y-hidden z-[1] justify-start lg:justify-center whitespace-nowrap">
  @for (comp of filteredComponents|orderBy: 'rank'; track comp) {
    <div
      class="w-fit h-full md:w-24 md:h-24 flex-shrink-0 border border-gris-3 rounded px-2 md:py-2 flex flex-col justify-between cursor-pointer hover:bg-gris-3 transition"
      [attr.data-scrollable-component-id]="comp.id"
      (click)="onComponentClick(comp)">
      <div class="hidden md:flex aspect-square w-14 mx-auto h-14 bg-white rounded flex items-center justify-center"
        [style.background]="'#' + icons[comp.family_id || comp.id]?.bg">
        <img [src]="$safeNavigationMigration(icons[comp.family_id || comp.id]?.url)" onerror="this.src='https://placehold.co/100x100'" class="w-10 h-10 object-contain" />
      </div>
      <p class="text-xs my-auto md:my-0 font-semibold text-center w-full truncate">{{ comp.name }}</p>
    </div>
  }
</div>
`,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [
        `
        .highlighted-component {
            background: rgba(248, 177, 51, 1);;
            border-color: rgba(248, 177, 51, 1);;
            color: white;
            transition: all 0.3s ease;
        }
        `
    ]
})
export class ComposantesScrollingCategoryComponent implements OnInit, OnChanges {
    private cdr = inject(ChangeDetectorRef);
    private gestion = inject(GestionService);
    private qdm = inject(QdmService);


    readonly service = input<ServiceItem>();
    readonly scrollToComponentRequested = output<RankItem>();

    protected icons: { [key: string]: { bg: string, url: string } } = {};
    sub: Subscription = new Subscription();
    admissionServicesIds: number[] = [];
    bypassComposantesFiltering: boolean = false;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['service']) {
            this.cdr.detectChanges();
            this.loadServiceIcons();
        }
    }

    loadServiceIcons() {
        const service = this.service();
        if (!service) return;

        this.gestion.fetchServicesIcones(service?.components.map(c => c.family_id || c.id)).then(icons => {
            this.icons = icons;
            
            this.cdr.detectChanges();
        });
    }

    ngOnInit(): void {
        this.sub.add(this.qdm.selectedAdmission$.subscribe(admission => {
            if(!admission){
                this.admissionServicesIds = [];
                this.bypassComposantesFiltering = false;
                return;
            }

            this.admissionServicesIds = admission.admissionParts.map(part => part.serviceId);
            this.bypassComposantesFiltering = admission.isFullMenu;
        }));
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
    
    onComponentClick(rank: RankItem) {
        this.scrollToComponentRequested.emit(rank);
    }

    get filteredComponents(): RankItem[] {
        if (this.bypassComposantesFiltering) return this.service()?.components || [];

        if(this.admissionServicesIds.length === 0) return this.service()?.components || [];
        
        return this.service()?.components.filter(comp => this.admissionServicesIds.includes(comp.family_id || comp.id)) || [];
    }
}
